import { useQuery } from '@tanstack/react-query';
import { financialService } from '../../services/financial.service';
import { queryKeys } from '../../lib/query-keys';

export function useBudgets(orgId: string | null) {
  return useQuery({
    queryKey: queryKeys.budgets.all(orgId ?? ''),
    queryFn: () => financialService.getProjectBudgets(orgId!),
    enabled: !!orgId,
    staleTime: 30_000,
    select: (res: any) => {
      const raw = res?.data ?? res;
      return Array.isArray(raw) ? raw : (raw?.data ?? []);
    },
  });
}

export function useProjectBudgets(orgId: string | null, projectId: string | null) {
  return useQuery({
    queryKey: queryKeys.budgets.byProject(orgId ?? '', projectId ?? ''),
    queryFn: async () => {
      const res = await financialService.getProjectBudgets(orgId!, projectId!);
      const raw = (res as any)?.data ?? res;
      return Array.isArray(raw) ? raw : (raw?.data ?? []);
    },
    enabled: !!orgId && !!projectId,
    staleTime: 30_000,
  });
}

export function useProjectBudgetSummary(projectId: string | null) {
  return useQuery({
    queryKey: queryKeys.budgets.projectSummary(projectId ?? ''),
    queryFn: async () => {
      const res = await financialService.getProjectBudgetSummary(projectId!);
      return (res as any)?.data ?? res;
    },
    enabled: !!projectId,
    staleTime: 60_000,
  });
}

export function useProjectChangeOrders(orgId: string | null, projectId: string | null) {
  return useQuery({
    queryKey: queryKeys.budgets.changeOrders(orgId ?? '', projectId ?? ''),
    queryFn: async () => {
      const res = await financialService.getBudgetChangeOrders(orgId!, projectId!);
      const raw = (res as any)?.data ?? res;
      return Array.isArray(raw) ? raw : (raw?.data ?? []);
    },
    enabled: !!orgId && !!projectId,
    staleTime: 30_000,
  });
}
